import { render, staticRenderFns } from "./CustomerProductCard.vue?vue&type=template&id=0ce28d8e&scoped=true"
import script from "./CustomerProductCard.vue?vue&type=script&lang=js"
export * from "./CustomerProductCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerProductCard.vue?vue&type=style&index=0&id=0ce28d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce28d8e",
  null
  
)

export default component.exports